import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import { Observable } from "rxjs";
import { ResponseListingPerformanceEval, RequestGetEmp360Dto, ResponseGetEmp360Dto } from "../dto/performance-evaluation.dto";
import { ResponsePaging } from "../../nest-responses";

@Injectable()
export class PerformanceEvaluationApi {

  private service: string = '';
  private model: string = 'sf6s/performanceEvaluation';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(payload: ResponseListingPerformanceEval, page: string | number, limit: string | number): Observable<ResponseListingPerformanceEval> {
    const method: string = 'POST';
    const func: string = 'listing';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseListingPerformanceEval>(method, url, params, urlParams, body, contentType, (10 * 60) * 1000);
  }

  public history(requestNo: string, periodCode: string, empId: string, referenceDate: Date, formNo: string, planformno: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof referenceDate !== 'undefined' && referenceDate !== null) urlParams.referenceDate = referenceDate;
    if (typeof formNo !== 'undefined' && formNo !== null) urlParams.formNo = formNo;
    if (typeof planformno !== 'undefined' && planformno !== null) urlParams.planformno = planformno;
    
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, null, 100000);
  }

  public empData(periodCode: string, empId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'empData';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public evaluationHistory(empId: string, page: number, limit: number): Observable<any> {
    const method: string = 'GET';
    const func: string = 'evaluationHistory';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  add(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "add";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, null, 1000000);
  }

  public answer360(periodCode: string, revieweeEmpid: string, raterEmpid: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'answer360';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof revieweeEmpid !== 'undefined' && revieweeEmpid !== null) urlParams.revieweeEmpid = revieweeEmpid;
    if (typeof raterEmpid !== 'undefined' && raterEmpid !== null) urlParams.raterEmpid = raterEmpid;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public additionalNotes(periodCode: string, formNo: string, lstreviewer: any, referenceDate: Date): Observable<any> {
    const method: string = 'GET';
    const func: string = 'additionalNotes';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof formNo !== 'undefined' && formNo !== null) urlParams.formNo = formNo;
    if (typeof lstreviewer !== 'undefined' && lstreviewer !== null) urlParams.lstreviewer = lstreviewer;
    if (typeof referenceDate !== 'undefined' && referenceDate !== null) urlParams.referenceDate = referenceDate;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getEmp(payload: RequestGetEmp360Dto): Observable<ResponsePaging<ResponseGetEmp360Dto>> {
    const method: string = 'POST';
    const func: string = 'getEmp';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof payload.limit !== 'undefined' && payload.limit !== null) urlParams.limit = payload.limit;
    if (typeof payload.page !== 'undefined' && payload.page !== null) urlParams.page = payload.page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseGetEmp360Dto>>(method, url, params, urlParams, body);
  }

  submitRater(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "submitRater";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public performancePlanRequest(requestNo: string): Observable<any> {
    console.log('performanceEvaluationRequest')
    const method: string = 'GET';
    const func: string = 'performanceEvaluationRequest';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public threeSixtyQuestionHistory(periodCode: string, revieweeEmpid: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'threeSixtyQuestionHistory';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof periodCode !== 'undefined' && periodCode !== null) urlParams.periodCode = periodCode;
    if (typeof revieweeEmpid !== 'undefined' && revieweeEmpid !== null) urlParams.revieweeEmpid = revieweeEmpid;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/performance-evaluation.api.ts